import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { REQUEST_TYPE_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformRequestTypeToLegacy = (requestType) => {
	if (!requestType) return null;

	return {
		requestType: {
			id: parseInt(requestType.requestTypeId, 10),
			issueTypeId: requestType.issueType?.issueTypeId || '',
			name: requestType.name || '',
			icon: {
				_links: {
					iconUrls: {
						'48x48': requestType.avatar?.large || '',
					},
				},
			},
		},
	};
};

export const transformAggJSMRequestTypeToLegacyField: FieldTransformer = (node) => {
	if (node.type !== REQUEST_TYPE_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformRequestTypeToLegacy(node.requestType),
		schema: {
			configuration: null,
			custom: REQUEST_TYPE_CF_TYPE,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			type: 'sd-customerrequesttype',
		},
	};
};
